export default __webpack_public_path__ + "static/media/portfolio-cia-3.2910dd88.jpg";